<template>
  <generic-list
    :query-fields="queryFields"
    :columns="columns"
    :form-fields="formFields"
    :editable-fields="editableFields"
    :fetch-data="fetchData"
    :add-data="addData"
    :update-data="updateData"
    :delete-data="deleteData"
    :add-fields="addFields"
  />
</template>

<script>
import GenericList from '@/components/GenericList.vue';
import { getLotteryGames, createLotteryGame, updateLotteryGame, deleteLotteryGame } from '@/api/lotteryGame';

export default {
  name: 'GameManagement',
  components: {
    GenericList
  },
  data() {
    return {
      queryFields: [
        { prop: 'name', label: '游戏名称', type: 'input' },
        { prop: 'status', label: '状态', type: 'select', options: [
          { label: '停用', value: 0 },
          { label: '启用', value: 1 }
        ]}
      ],
      columns: [
        { prop: 'id', label: 'ID' },
        { prop: 'name', label: '游戏名称' },
        { prop: 'close_seconds', label: '提前封盘秒数' },
        { prop: 'category_id', label: '所属类型' },
        { prop: 'status', label: '状态' },
        { prop: 'sort_order', label: '排序' },
        { prop: 'logo', label: 'Logo' }
      ],
      formFields: [
        { prop: 'id', label: 'ID', type: 'input' },
        { prop: 'name', label: '游戏名称', type: 'input' },
        { prop: 'label', label: '标签', type: 'input' },
        { prop: 'close_seconds', label: '提前封盘秒数', type: 'input', inputType: 'number' },
        { prop: 'config_data', label: '游戏配置数据', type: 'json-editor' },
        { prop: 'category_id', label: '所属类型', type: 'input', inputType: 'number' },
        { prop: 'status', label: '状态', type: 'select', options: [
          { label: '停用', value: 0 },
          { label: '启用', value: 1 }
        ]},
        { prop: 'sort_order', label: '排序', type: 'input', inputType: 'number' },
        { prop: 'logo', label: 'Logo', type: 'image-upload', action: process.env.VUE_APP_API_BASE_URL + '/upload', headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') }, limit: 1, accept: 'image/*' }
      ],
      editableFields: [
        'id',
        'name',
        'close_seconds',
        'config_data',
        'category_id',
        'status',
        'sort_order',
        'logo'
      ],
      addFields: [
        'name',
        'label',
        'close_seconds',
        'config_data',
        'category_id',
        'status',
        'sort_order',
        'logo'
      ]
    };
  },
  methods: {
    async fetchData(queryParams) {
      try {
        const response = await getLotteryGames(queryParams);
        return {
          data: {
            list: response.data.rows,
            total: response.data.count
          }
        };
      } catch (error) {
        console.error('API Error:', error);
        throw error;
      }
    },
    addData(data) {
      const editableData = {};
      this.addFields.forEach(field => {
        if (data[field] !== undefined) {
          editableData[field] = data[field];
        }
      });
      console.log(editableData);
      return createLotteryGame(editableData);
    },
    updateData(data) {
      const editableData = {};
      this.editableFields.forEach(field => {
        if (data[field] !== undefined) {
          editableData[field] = data[field];
        }
      });
      return updateLotteryGame(data.id,editableData);
    },
    deleteData(id) {
      return deleteLotteryGame(id);
    }
  }
};
</script>

<style scoped>
/* 添加自定义样式 */
</style>